import { render, staticRenderFns } from "./ToReviewer.vue?vue&type=template&id=ceaf338a&scoped=true&"
import script from "./ToReviewer.vue?vue&type=script&lang=js&"
export * from "./ToReviewer.vue?vue&type=script&lang=js&"
import style0 from "./ToReviewer.vue?vue&type=style&index=0&id=ceaf338a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceaf338a",
  null
  
)

export default component.exports